<div class="chatbox" [class.chatbox--active]="isChatOpen">
  <div class="chatbox__support">
    <div class="chatbox__header">
      <div class="chatbox__image--header">
        <i class="fa-solid fa-book-bookmark"></i>
      </div>
      <div class="chatbox__content--header">
        <h4 class="chatbox__heading--header">Chat support</h4>
        <p class="chatbox__description--header">Hi. My name is Sam. How can I help you?</p>
      </div>
    </div>
    <div class="chatbox__messages">
      @for(message of messages; track message){
      <div>
        @if(message.name === 'Sam'){
        <div class="messages__item messages__item--visitor" [innerHTML]="sanitizeHtml(message.message)"></div>
        }@else{
        <div class="messages__item messages__item--operator">{{ message.message }}</div>
        }
      </div>
      }
    </div>
    <div class="chatbox__footer">
      <input [(ngModel)]="messageText" type="text" placeholder="Write a message..." (keyup.enter)="sendMessage()">
      <button class="chatbox__send--footer send__button" (click)="sendMessage()">Send</button>
    </div>
  </div>
  <div class="chatbox__button">
    <button (click)="toggleChat()">chat with me</button>
  </div>
</div>
